'use client'
// import { ConfirmPaymentPcs } from "@/api/calculate/route"
import React, { useEffect, useState, useContext } from 'react'
import Check from '../../assets/check.svg'
import Echec from '../../assets/iconEchec.svg'
import Fleche from '../../assets/flecheRight.svg'
import LogoEasy from '../../assets/logoMyEasy.svg'
import Fb from '../../assets/iconTsx/FacebookWhite'
import Linkedin from '../../assets/iconTsx/LinkedinWhite'
import Youtube from '../../assets/iconTsx/youtubeWhite'
import Tiktok from '../../assets/iconTsx/TiktokWhite'
import Instagram from '../../assets/iconTsx/InstagramWhite'
import { ConfirmpaymentInvoices, ConfirmpaymentRecharge, PaymentConfirmedCarte } from 'requests/paiement'
import UserContext from 'contexts/UserContext'

const Success = () => {
  const [isLoading, setIsloading] = useState(true)
  const [isAwaiting, setIsAwaiting] = useState(false)

  const reseauSocial: { lien: string; Icon: any }[] = [
    { lien: 'https://www.facebook.com/MyEasyTransfer?sfnsn=scwspwa', Icon: Fb },
    {
      lien: 'https://www.linkedin.com/company/my-easy-transfer/',
      Icon: Linkedin,
    },
    { lien: 'https://www.youtube.com/@myeasytransfer6740', Icon: Youtube },
    { lien: 'https://www.tiktok.com/@myeasytransfer_', Icon: Tiktok },
    {
      lien: 'https://www.instagram.com/myeasytransfer/?hl=fr',
      Icon: Instagram,
    },
  ]
  const openLink = (url: string) => {
    window.open(url, '_blank')
  }

  const { user } = useContext(UserContext)
  const token = user?.token?.accessToken

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const paymentId = searchParams.get('paymentId')
    const merchantPaymentId = searchParams.get('merchantPaymentId')
    const status = searchParams.get('status')

    if (status === 'AWAITING_AUTHORIZATION' || status === 'FAILED') {
      setIsAwaiting(true)
    }

    async function fetchData() {
      if (!paymentId || !merchantPaymentId) {
        console.log('Paramètres manquants')
        return
      }

      try {
        const body = {
          paymentId: paymentId,
          merchantPaymentId: merchantPaymentId,
          paymentStatus: status,
        }
        let response = null
        if (merchantPaymentId.includes('prepaid'))
         {response = await PaymentConfirmedCarte(body)}
        else if (merchantPaymentId.includes('recharge'))
        {response= await ConfirmpaymentRecharge(body) }
        else if(merchantPaymentId.includes('invoice'))
        { response=await ConfirmpaymentInvoices(body)}
        if (response) {
          setIsloading(false)
        }
      } catch (error) {
        console.error('error', error)
        setIsloading(false)
      } finally {
        setIsloading(false)
      }
    }

    fetchData()
  }, [])

  const handleClick = () => {
    // const deepLink = 'https://app-dev.myeasytransfer.com/history?activeText=4'
    const deepLink = 'https://app.myeasytransfer.com/history?activeText=4'

    window.location.assign(deepLink)
  }

  return (
    <div className="">
      <div className="flex flex-col items-center justify-center w-full gap-10">
        <div className="w-full">
          <div
            className={`${isAwaiting ? 'bg-[#EE443F]' : 'bg-[#43B75D]'}  w-full gap-3 flex items-center justify-center text-[#FFFFFF] h-[70px] text-[32px] lg:text-[20px] text-center`}
          >
            <img
              className="w-8 h-auto"
              width={18}
              height={19}
              src={isAwaiting ? Echec : Check}
              alt="operation réussi"
            />{' '}
            <p className='lg:w-[250px]'>{isAwaiting ? 'Un blocage est survenu dans le processus' : 'Réussi!'}</p>
          </div>
          <div className={` ${isAwaiting ? 'bg[#DE3530]' : 'bg-[#2FAC4B] '}w-full h-[5px] `} />
        </div>

        <img className="h-[80px] w-auto mt-10" src={LogoEasy} width={149} height={54} alt="" />

        <div className="text-[#1D3A70] text-center leading-7">
          {isAwaiting ? <p>❌ Votre recharge a échoué.</p> : <p>✅ Votre recharge a été effectuée avec succès !</p>}
          Cliquez sur le bouton ci-dessous pour finaliser le processus.
        </div>

        <button
          // disabled={isLoading}
          className=" w-[160px] h-[48px] px-5 border-[#5754E5] border text-[#5754E5]  hover:bg-[#F1F1FF] rounded-full"
          onClick={handleClick}
        >
          {isLoading ? (
            <div className="flex">
              loading
              <svg
                className="w-6 h-6 mx-auto animate-spin text-[#5754E5] "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle className="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                ></path>
              </svg>
            </div>
          ) : (
            <div className="flex items-center justify-between">
              {' '}
              Terminer <img src={Fleche} alt="" />{' '}
            </div>
          )}
        </button>

        <div className=" fixed  bottom-0  bg-[#F1F1FF] w-full  ">
          <div className="flex w-full flex-col items-center justify-center text-[#5754E5] h-[220px]">
            <h2 className="text-[32px] font-bold">Nos Contacts</h2>
            <div>0033189162883</div>
            <a
              className="text-[#5754E5]"
              href="mailto:contact@myeasytransfer.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              contact@myeasytransfer.com
            </a>

            <a href="https://www.myeasytransfer.com/" target="_blank" rel="noopener noreferrer">
              www.myeasytransfer.com
            </a>
            <div className="flex mt-4 items-center gap-4">
              {reseauSocial.map(({ lien, Icon }, index) => (
                <Icon key={index} onClick={() => openLink(lien)} className=" hover:text-[#9683FF] cursor-pointer" />
              ))}
            </div>
          </div>
          <div className="w-full fixed bottom-0 h-[5px] bg-[#5754E5]" />
        </div>
      </div>
    </div>
  )
}

export default Success
